import { Layout } from 'antd';

const LayoutFooter = () => {
    return <Layout.Footer style={{ textAlign: 'center' }}>Boost 2024</Layout.Footer>;
};

export default LayoutFooter;
